import React, { useEffect, useState } from "react";
import FilterBar from "../shared/FilterBar";
import GenericTable from "../generic/GenericTable";
import { InventoryRecord } from "../../types/InventoryItem";
import FormComponent from "../generic/FormComponent";
import TotalBalance from "../shared/TotalBalance";

interface InventoryListProps {
}

const InventoryList: React.FC<InventoryListProps> = ({}) => {
    const [ filters, setFilters ] = useState<{
        material_type_id: number | null;
        color_code: string | null;
        material_size_id: number | null;
        hideZero: boolean;
        records: InventoryRecord[];
    }>({
        material_type_id: null,
        color_code: null,
        material_size_id: null,
        hideZero: false,
        records: [], // Ensure this is an array
    });

    const [ filteredRecords, setFilteredRecords ] = useState<InventoryRecord[]>(filters.records || []);
    const [ currentPage, setCurrentPage ] = useState<number>(1);

    // Apply filters whenever filters or records change
    const applyFilters = () => {
        if (filters.records.length === 0) {
            setFilteredRecords([]); // No records to filter
            return;
        }

        const result = filters.records.filter((item: InventoryRecord) => {
            const matchesType =
                filters.material_type_id === null || // Allow all if no type filter
                item.material_type_id === filters.material_type_id;
            const matchesSize =
                filters.material_size_id === null || // Allow all if no size filter
                item.material_size_id === filters.material_size_id;
            const matchesColor =
                filters.color_code === null || // Allow all if no color filter
                item.color_code === filters.color_code;
            const matchesHideZero = !filters.hideZero || item.quantity > 0;

            return matchesType && matchesSize && matchesColor && matchesHideZero;
        });
        setFilteredRecords(result);
    };

    useEffect(() => {
        applyFilters();
    }, [ filters ]);

    const tableData = filteredRecords.map((item) => {
        const price = item.average_price_per_unit;
        const displayPrice = price ? parseFloat(price.toFixed(4)) : 0;

        return {
            "Material Type": item.material_type || "-",
            "Material Size": item.material_size || "-",
            "Color Name": `${item.color_name || "-"} (${item.color_code || "-"})`,
            "Quantity": `${item.quantity} ${item.quantity_unit || ""}`,
            "Material Description": item.material_description || "-",
            // Unit Price with up to 4 decimals, no excessive trailing zeros
            "Unit Price": `$${displayPrice}/${item.quantity_unit || "unit"}`,
            "Balance": `$${item.balance?.toFixed(2) || "0.00"}`,
            "Created At": item.created_at || "-",
            "Updated At": item.updated_at || "-",
        };
    });


    const totalBalance = filteredRecords.reduce(
        (sum, item) => sum + (item.balance || 0),
        0,
    );

    return (
        <div>
            <FormComponent title="Inventory List">
                <FilterBar filters={filters} onFilterChange={setFilters}/>
                {/* Display Total Balance */}
                <TotalBalance totalBalance={totalBalance}/>
                <GenericTable
                    columns={[
                        "Material Type",
                        "Material Size",
                        "Color Name",
                        "Quantity",
                        "Material Description",
                        "Unit Price",
                        "Balance",
                        "Created At",
                        "Updated At",
                    ]}
                    data={tableData}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                />
            </FormComponent>
        </div>
    );
};

export default InventoryList;
